module.exports = "<h1 id=\"vbl-utils\">vbl.utils</h1>\n<p>公共js</p>\n<h2 id=\"installation\">Installation</h2>\n<pre><code>$ npm install vbl.utils --save\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/vbl.utils/README.md
// module id = 134
// module chunks = 0